<template>
  <section>
    <div>
      <h2 class="font-italic text-center">
        Instructions to reset your password will be sent to your email address.
      </h2>
    </div>
    <div class="row-btn mt-4">
      <router-link to="/login" class="btn btn-primary">Go to login</router-link>
    </div>											
  </section>
</template>

<script>
export default {
  /*created(){
    this.$emit('set-style', "background-image: url(img/bg-change-psw.jpg)");
  }*/
}
</script>